import * as constants from "./constants";

export const fetchSuppliers = (data) => {
  return {
    type: constants.FETCH_SUPPLIERS,
    data,
  };
};

export const fetchSuppliersSuccess = (data) => {
  return {
    type: constants.FETCH_SUPPLIERS_SUCCESS,
    data: data,
  };
};

export const fetchSuppliersError = (data) => {
  return {
    type: constants.FETCH_SUPPLIERS_ERROR,
    data: data,
  };
};

export const updateSupplier = (data) => {
  return {
    type: constants.UPDATE_SUPPLIERS,
    data: data,
  };
};

export const updateSupplierSuccess = (data) => {
  return {
    type: constants.UPDATE_SUPPLIERS_SUCCESS,
    data: data,
  };
};

export const updateSupplierError = () => {
  return {
    type: constants.UPDATE_SUPPLIERS_ERROR,
  };
};

export const deleteSupplier = (data) => {
  return {
    type: constants.DELETE_SUPPLIERS,
    data: data,
  };
};

export const deleteSupplierSuccess = (data) => {
  return {
    type: constants.DELETE_SUPPLIERS_SUCCESS,
    data: data,
  };
};

export const deleteSupplierError = () => {
  return {
    type: constants.DELETE_SUPPLIERS_ERROR,
  };
};

export const createSupplier = (data) => {
  return {
    type: constants.CREATE_SUPPLIERS,
    data: data,
  };
};

export const createSupplierSuccess = (data) => {
  return {
    type: constants.CREATE_SUPPLIERS_SUCCESS,
    data: data,
  };
};

export const createSupplierError = () => {
  return {
    type: constants.CREATE_SUPPLIERS_ERROR,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};
